import { COMBAT } from "../data/balance.js";

/**
 * 1회 발사 시 실제 생성될 발사체 수 (순수 — SSoT).
 *
 * `spec.count`는 모듈 효과 누적으로 소수가 될 수 있으나 발사체는 정수 개만 생성되므로 **floor 후 clamp**한다.
 * 범위는 [1, maxPerFire] — count가 0/음수/NaN이어도 최소 1발, 상한 초과는 maxPerFire로 cap.
 *
 * ⚠ 이 함수가 SSoT인 이유: 과거 ProjectileFactory(실제 발사)는 floor를, combatStats(DPS 추정)는 floor를
 * 누락해 소수 count에서 발사 수와 표시 DPS가 어긋났다. 두 호출처가 본 함수를 공유해 불일치를 제거한다.
 */
export function resolveFireCount(
  rawCount: number,
  maxPerFire: number = COMBAT.maxProjectilesPerFire,
): number {
  if (Number.isNaN(rawCount)) return 1;
  return Math.min(maxPerFire, Math.max(1, Math.floor(rawCount)));
}
